import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Compare"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M21 4.5H13.5V3C13.5 2.17157 12.8284 1.5 12 1.5H3C2.17157 1.5 1.5 2.17157 1.5 3V18C1.5 18.8284 2.17157 19.5 3 19.5H10.5V21C10.5 21.8284 11.1716 22.5 12 22.5H21C21.8284 22.5 22.5 21.8284 22.5 21V6C22.5 5.17157 21.8284 4.5 21 4.5ZM3 11.25H7.6275L5.6925 13.1925L6.75 14.25L10.5 10.5L6.75 6.75L5.6925 7.8075L7.6275 9.75H3V3H12V18H3V11.25ZM12 21V19.5C12.8284 19.5 13.5 18.8284 13.5 18V6H21V12.75H16.3725L18.3075 10.8075L17.25 9.75L13.5 13.5L17.25 17.25L18.3075 16.1925L16.3725 14.25H21V21H12Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Compare.vue"]]);
